// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate'
import Toasted from 'vue-toasted'
import Croppa from 'vue-croppa'
import VueMask from 'v-mask'

import '../i18n/index'
import '../metrics'
import '../config/toasted'
import '../router/Authorization'

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://dd904af15e4c44aca31ef227f8784daf@o467388.ingest.sentry.io/5493774",
  environment: process.env.VUE_APP_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(Toasted)
Vue.use(Croppa)
Vue.use(VueMask)

import ActionCableVue from 'actioncable-vue';
Vue.use(ActionCableVue, {
  debug: process.env.VUE_APP_ACION_CABLE_DEBUG,
  debugLevel: process.env.VUE_APP_ACION_CABLE_DEBUG_LEVEL,
  connectionUrl: process.env.VUE_APP_ACTION_CABLE_URL,
  connectImmediately: true,
});

Vue.use(ColorThemePlugin, {
  // Add or change theme colors here
  themes: {
    primary: store.state.colorPrimary,
    secondary: store.state.colorSecondary,
    success: '#000000',
    info: store.state.colorSecondary,
    danger: '#A51433',
    warning: '#FFC200',
    gray: '#7F8386',
    dark: '#34495E',
    third: '#FFFFFF',
    green: '#077307',
    greenLight: '#40E583',
    orangeRed: '#DF3A01',
    black: '#000000'
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Croppa,
  render: h => h(App),
})